import { SearchService } from "@lib/constants/variants";
import { useEffect, useState } from "react";

export const useImageBySearch = (src: string, type = 'yelp', size = 800) => {
    const [isLoading, setIsLoading] = useState(true);
    const [imageSrc, setImageSrc] = useState(src);

    useEffect(() => {
        setIsLoading(true);
        if (src) {
            if (type === SearchService.YELP) {
                setImageSrc(src);
                setIsLoading(false);
            } else {
                const getImage = async () => {
                    const url = `https://places.googleapis.com/v1/${src}/media?key=${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}&maxWidthPx=${size}&maxHeightPx=${size}`;
                    try {
                        const response: any = await fetch(url);
                        if (!response.ok) {
                            setIsLoading(false);
                            throw new Error(`Response status: ${response.status}`);
                        }
                        setImageSrc(response?.url);
                        setIsLoading(false);
                    } catch (error) {
                        console.log(error);

                    } finally {
                        setIsLoading(false);
                    }
                }
                getImage();
            }
        }

    }, [src]);

    return { isLoading, imageSrc };
};